import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { SUPPORTED_LANGS } from "@/i18n/I18nProvider";

function stripLang(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length > 0 && SUPPORTED_LANGS.includes(parts[0])) {
    return "/" + parts.slice(1).join("/");
  }
  return pathname || "/";
}

/**
 * Scrolls to top on route changes, but NOT when only the language prefix changes.
 * We detect a language-only change by comparing the pathname stripped of the
 * language segment. If the "content" path is unchanged, we skip scrolling.
 */
export default function ScrollToTop() {
  const location = useLocation();
  const lastContentPath = useRef(stripLang(location.pathname));

  useEffect(() => {
    const nextContent = stripLang(location.pathname);
    if (nextContent === lastContentPath.current) {
      // language-only change – keep scroll position
      return;
    }
    lastContentPath.current = nextContent;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return null;
}
